const CourseCard = ({ cardData, currentCard, setCurrentCard }) => {
  return (
    <div
      className={`relative w-full sm:w-[360px] md:w-[48%] lg:w-[30%] aspect-[4/3] ${currentCard === cardData?.heading
          ? "bg-richblack-800 "
          : "bg-richblack-800"
        } text-richblack-25 box-border cursor-pointer rounded-2xl overflow-hidden group transition-all duration-300`}
      onClick={() => setCurrentCard(cardData?.heading)}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-center bg-cover transition-transform duration-500 group-hover:scale-110"
        style={{
          backgroundImage: `url(${cardData.imageUrl || '/default-image.jpg'})`, 
          backgroundSize: 'contain', 
          backgroundPosition: 'center', 
          backgroundRepeat: 'no-repeat', 
        }}
      ></div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black transition-opacity duration-300 opacity-0 group-hover:opacity-40"></div>

      {/* Sliding Animation */}
      <div className="absolute inset-0 bg-richblack-800 transition-transform duration-500 transform -translate-y-full group-hover:translate-y-0 opacity-70"></div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-between items-center text-center text-[#CD1412] opacity-0 transition-opacity duration-500 group-hover:opacity-100 px-4 md:px-6">
        <div className="font-semibold text-[18px] sm:text-[20px] lg:text-[22px]">{cardData.heading}</div>
        <div className="text-richblack-5 mt-2 text-[14px] sm:text-[16px]">{cardData.description}</div>
        <div className="flex justify-between w-full px-6 py-3 font-medium">
          {/* Additional content like levels or lesson numbers can be added here */}
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
